<template>
  <div class="flex">
    <div
      class="fixed top-18 z-30 w-88 flex-shrink-0 border-r border-slate-400 bg-pure-white"
    >
      <div class="p-6 border-b border-slate-400 flex flex-col gap-3">
        <div>
          <BlTextTitle3 text="Client Acquisition Board" />
        </div>
        <div
          class="flex p-1 bg-slate-400"
          :style="{ borderRadius: '8px', height: '2.375rem' }"
        >
          <div
            v-for="opt in previewTypeOptions"
            :key="opt.value"
            class="rounded flex items-center justify-center gap-1 h-full cursor-pointer w-full transition-all duration-300"
            :class="
              previewTypeInput === opt.value ? 'bg-pure-white' : 'bg-slate-400'
            "
            @click="onChangePreviewType(opt.value)"
          >
            <BlIcon
              v-if="opt.value === 'kanban'"
              icon="kanban"
              color="slate-6"
              class="w-4 h-4"
            />
            <BlIcon
              v-if="opt.value === 'list'"
              icon="list"
              color="slate-6"
              class="w-4 h-4"
            />
            <BlTextSubtitle3 :text="opt.label" />
          </div>
        </div>
      </div>
      <div
        v-if="panelLoading"
        class="w-full grid place-items-center"
        :style="{ height: 'calc(100vh - 15.5rem)' }"
      ></div>
      <div
        v-else
        class="overflow-y-auto px-3 py-5"
        :style="{ height: 'calc(100vh - 15.5rem)' }"
      >
        <div class="flex items-center justify-between px-3 mb-3">
          <BlTextSubtitle3 text="Your upcoming to-dos" class="text-slate-600" />
          <BlBubbleCount :count="currentUser.upcoming_todos.length || 0" />
        </div>
        <div
          v-if="!currentUser.upcoming_todos.length"
          class="h-128 grid items-center justify-center"
        >
          <BlTextBody2 text="There are no upcoming to-dos." />
        </div>
        <div v-else class="px-3 flex flex-col">
          <div
            v-for="(instruction, idx) in currentUser.upcoming_todos"
            :key="instruction.id"
          >
            <UpcomingTodo :instruction="instruction" />
            <div
              v-if="idx + 1 < currentUser.upcoming_todos.length"
              class="h-0.5 w-full rounded bg-slate-300"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="previewTypeInput" class="pl-88 bg-slate-100">
      <PipelineKanban v-if="previewTypeInput === 'kanban'" />
      <ProspectTable v-if="previewTypeInput === 'list'" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import UpcomingTodo from "./UpcomingTodo.vue";
import PipelineKanban from "./pipeline/Kanban.vue";
import ProspectTable from "./prospects/Table.vue";

import BlTextTitle3 from "../BlTextTitle3.vue";
import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlBubbleCount from "../BlBubbleCount.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "ClientAcquisition",
  components: {
    UpcomingTodo,
    PipelineKanban,
    ProspectTable,
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody2,
    BlBubbleCount,
    BlIcon
  },
  data() {
    return {
      panelLoading: false,
      previewTypeInput: "", // kanban | list
      previewTypeOptions: [
        { value: "kanban", label: "Kanban" },
        { value: "list", label: "List" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"])
  },
  created() {
    this.getBranches({ params: "?sort=name_asc" });
  },
  mounted() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.add("bg-slate-100");
      app.classList.remove("bg-slate-200");
    }
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }
    if (!this.currentCenter.enable_sales_pipeline) {
      return this.$router.push({ name: "Clients" });
    }

    const searchParams = this.$route.query;
    if (searchParams["preview_type"]) {
      const found = this.previewTypeOptions.find(
        i => i.value === searchParams["preview_type"]
      );
      if (found) this.previewTypeInput = found.value;
      else this.previewTypeInput = "kanban";
    } else this.previewTypeInput = "kanban";

    this.getProspectStage({ id: null });
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) {
      app.scroll({ top: 0, left: 0 });
      app.classList.remove("bg-slate-100");
      app.classList.add("bg-slate-200");
    }
  },
  methods: {
    ...mapActions(["getBranches", "getProspectStage"]),
    onChangePreviewType(type) {
      this.previewTypeInput = type;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/ClientAcquisition.vue